<template>
  <dialog-base>
    <div ref="page"
         :class="{empty: isEmpty}"
         class="mod-prize">
      <div v-if="!isEmpty">
        <div class="content">
          <span class="primary">{{mete}}</span>元红包
        </div>
      </div>
      <div class="tip">
        <span v-if="num > 0">再找{{num}}个宝物即可开启宝箱</span>
      </div>
    </div>
    <div class="btn-red"
         @click="continueSearch">
      继续寻宝
    </div>
  </dialog-base>
</template>

<script>
import DialogBase from '../base'
import mixin from '../mixin'
export default {
  mixins: [mixin],
  components: {
    DialogBase
  },
  data() {
    return {
      mete: '',
      num: ''
    }
  },
  computed: {
    isEmpty() {
      return !this.mete
    }
  },
  mounted() {
  },
  methods: {
    continueSearch() {
      this.$stat({
        event: 'click_prize_continue'
      })
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-prize {
  position: relative;
  padding: 182px 112px 0;
  width: 725px;
  height: 795px;
  background-image: url("~@/assets/dialog/dialog-prize.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  &.empty {
    // padding: 42px 100px 0;
    width: 654px;
    height: 699px;
    background-image: url("~@/assets/dialog/dialog-prize-empty.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    .chest {
      margin-top: 39px;
    }
    .tip {
      top: 340px;
    }
  }
  .tip {
    position: absolute;
    top: 370px;
    left: 50%;
    transform: translateX(-50%) translateX(40px);
    font-size: 28px;
    color: #872c0c;
  }
  .title {
    font-weight: bold;
    text-align: center;
    font-size: 48px;
  }
  .content {
    text-align: center;
    font-size: 36px;
    .primary {
      font-size: 48px;
      font-weight: bolder;
    }
    color: #f57906;
  }
  .empty-text {
    margin: auto;
    width: 449px;
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    color: #f57906;
  }
  .chest {
    margin-top: 197px;
    padding: 30px;
    background: #fbebd8;
    border-radius: 30px;
    .header {
      text-align: center;
    }
    .list {
      margin-top: 24px;
      display: flex;
      justify-content: space-between;
      font-size: 26px;
      font-weight: bold;
      color: #ffffff;
    }
    .ico-moneychest-blue {
      padding: 90px 36px 0;
      width: 219px;
      height: 129px;
      text-align: center;
      background-image: url("~@/assets/ico/ico-moneychest-blue.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
      text-shadow: 0 -2px 0 #0b397c, 2px 0 0 #0b397c, 0 2px 0 #0b397c,
        -2px 0 0 #0b397c;
    }
    .ico-moneychest-gold {
      padding: 90px 36px 0;
      width: 219px;
      height: 129px;
      text-align: center;
      background-image: url("~@/assets/ico/ico-moneychest-gold.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
      text-shadow: 0 -2px 0 #872c0c, 2px 0 0 #872c0c, 0 2px 0 #872c0c,
        -2px 0 0 #872c0c;
    }
  }
}
.btn-red {
  margin-top: 48px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 479px;
  height: 95px;
  background-image: url("~@/assets/ico/btn-red.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  font-size: 35px;
  color: #ffffff;
  text-shadow: #872c0c 2px 0 2px, #872c0c 0 2px 2px, #872c0c -2px 0 2px,
    #872c0c 0 -2px 2px;
}
</style>